import React, { Component } from 'react';
import './Contact.css';
import { Heading } from '../../components';
import { contactContent } from '../../constants';

class Contacto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mailSent: false,
      error: null
    };
  }

  render() {
    return (
      <section className='contacto' id='Contacto'>
        <Heading title={'Contáctanos'} span={'Ponte en contacto'} />

        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDG0VS6YcuKKjIsYx7BHG_JXUOD6e-nflw&q=Osorno+651,+Coquimbo"
          width="600"
          height="450"
          allowFullScreen
          loading="lazy">
        </iframe>


        <div className='contenedor'>
          <div className='info-contacto'>
            <h3>Información de contacto</h3>

            <div className='contenedor'>
              {contactContent.map((contacto) => {
                let detalles = contacto.content;
                return (
                  <div className='item-info' key={contacto.id}>
                    <div className='icono-item'>
                      <div className='icono'>{contacto.icon}</div>
                    </div>
                    <div className='contenido'>
                      <h4>{contacto.title}</h4>
                      <ol>
                        {detalles.map((item, index) => (
                          <p key={index}>{item}</p>
                        ))}
                      </ol>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className='mensaje-correo'>
            <h3>Envíanos un correo</h3>
            <p>Si tienes alguna pregunta o deseas comunicarte con nosotros, por favor envíanos un correo a: <a href="mailto:contacto@shccingenieria.cl">contacto@shccingenieria.cl</a>.</p>
          </div>
        </div>
      </section>
    );
  }
}

export default Contacto;
